import { useRef } from 'react';
import { FormField } from 'ui/formField';
import { WebPushContentDefinition } from 'modules/graphql/types';
import { TextInputField } from '../../common/components';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useErrorValidationContext } from '../../context/ErrorValidationContext';
import { ContentType, FieldNames, MediumDataKey } from '../../common/types';
import { WebPushRestrictionText } from '../../common/RestrictionText';
import { constructFieldErrors } from '../../common/utils';
import { constructErrorInlineText } from '../../common/ErrorInlineText';

const WEB_PUSH_TITLE: MediumDataKey = 'title';

const displayContent = {
  labelText: 'Title',
};

export const WebPushTitleField = () => {
  const { liveTemplate, setCurrentMediumField, isEditMode } = useEditableFieldsContext();
  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();
  const webPushData = (liveTemplate?.mediumData ?? {}) as WebPushContentDefinition;
  const webPushDataTitle = webPushData.title ?? '';
  const titleRef = useRef<HTMLInputElement | null>(null);

  const { hasError: hasWebPushTitleError, hasWarning: hasWebPushTitleWarning } =
    constructFieldErrors({
      contentErrors: localeContentErrors,
      contentWarnings: localeContentWarnings,
      fieldName: FieldNames.TITLE,
    });
  const webPushTitleErrorText = constructErrorInlineText({
    hasError: hasWebPushTitleError,
    hasWarning: hasWebPushTitleWarning,
    condition: isEditMode,
  });

  const restrictionTextLabel = () => (
    <WebPushRestrictionText
      textContent={webPushDataTitle}
      messageLength={webPushDataTitle.length}
      contentType={ContentType.TITLE}
    />
  );

  return (
    <FormField
      data-test="web-push-title-field"
      labelText={displayContent.labelText}
      restrictionText={restrictionTextLabel()}
      isHorizontalLayout
      hasError={hasWebPushTitleError}
      hasWarning={hasWebPushTitleWarning}
      errorText={webPushTitleErrorText}
      warningText={webPushTitleErrorText}
    >
      <TextInputField
        hasError={hasWebPushTitleError}
        hasWarning={hasWebPushTitleWarning}
        mediumRef={titleRef}
        mediumDataKey={WEB_PUSH_TITLE}
        mediumDataValue={webPushData.title}
        changeHandler={(content: string) => setCurrentMediumField('title', content)}
      />
    </FormField>
  );
};
